import { useQuery } from '@tanstack/react-query';
import { getOrganizationUserDetail } from '../services/requests';

interface UseGetUserDetailOptions {
  enabled?: boolean;
}

export const useGetUserDetail = (id: string, options?: UseGetUserDetailOptions) => {
  return useQuery({
    queryKey: ['organizationUserDetail', id],
    queryFn: () => getOrganizationUserDetail(id),
    enabled: options?.enabled !== false && !!id,
  });
};
